exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.switch.switch-text.switch-lg.wide-toggle[data-v-9dca2dd2]{width:180px\n}\n.switch.switch-text.switch-lg.wide-toggle .switch-input:checked~.switch-handle[data-v-9dca2dd2]{left:154px\n}\n.switch.switch-text.switch-lg.wide-toggle .switch-label[data-v-9dca2dd2]::after,.switch.switch-text.switch-lg.wide-toggle .switch-label[data-v-9dca2dd2]::before{width:156px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-9dca2dd2","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/t1/Admin/UserForm.vue
// module id = 1844
// module chunks = 0